import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import { defineComponent as _defineComponent } from 'vue';
import { CredentialType } from '@tickethead/sdk';
import IconMenu from '~/components/general/icons/IconMenu.vue';
import IconSearch from '~/components/general/icons/IconSearch.vue';
import IconBack from '~/components/general/icons/IconBack.vue';
import IconCancel from '~/components/general/icons/IconCancel.vue';
import GooglePlay from '~/components/common/icons/stores/GooglePlay.vue';
import AppStore from '~/components/common/icons/stores/AppStore.vue';
import BImpersonated from '~/components/general/BImpersonated.vue';
import BLanguageSwitcher from '~/components/general/BLanguageSwitcher.vue';
import BLoggedUser from '~/components/general/BLoggedUser.vue';
import { useOrdersStore } from '~/store/orders';
import { useEventsStore } from '~/store/events';
import { useOrganizerSignupStore } from '~/store/organizerSignup';
import { useUserStore } from '~/store/user';
import { useAppStore } from '~/store/app';
export default /*#__PURE__*/_defineComponent({
  __name: 'BHeader',
  props: {
    isFixed: {
      type: Boolean,
      default: false
    },
    isDashboard: {
      type: Boolean,
      default: false
    },
    hasMaxWidth: {
      type: Boolean,
      default: false
    },
    padding: {
      type: Number,
      default: 0
    },
    isPublishScreen: {
      type: Boolean,
      default: false
    },
    isMaintenancePage: {
      type: Boolean,
      default: false
    }
  },
  emits: ['openLogin'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var userStore = useUserStore();
    var appStore = useAppStore();
    var ordersStore = useOrdersStore();
    var eventsStore = useEventsStore();
    var organizerSignupStore = useOrganizerSignupStore();
    var auth = useAuth();
    var sdk = useSdk();
    var router = useRouter();
    var localePath = useLocalePath();
    var notifier = useNotifier();
    var nuxtEventBus = useNuxtEventBus();
    var featurebaseReset = useFeaturebase();
    var whitelabel = useWhitelabel();
    var whitelabelLite = useWhitelabelLite();
    var config = useRuntimeConfig();
    var _useFeatureFlags = useFeatureFlags(),
      enableOrganizers = _useFeatureFlags.enableOrganizers;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var mobileMenu = ref(false);
    var showOrganizer = enableOrganizers;
    var searchTerm = ref('');
    var isScrolled = ref(false);
    var isInfoPage = ref(false);
    var isDashboardInfoPage = ref(false);
    var getDashboardUrl = computed(function () {
      return userStore.getDashboardUrl;
    });
    var getUserEmail = computed(function () {
      return userStore.getUserEmail;
    });
    var canAccessMobileDashboard = computed(function () {
      return userStore.canAccessMobileDashboard;
    });
    var userCanAccessDashboard = computed(function () {
      return appStore.userCanAccessDashboard;
    });
    var getOrganizer = computed(function () {
      return appStore.getOrganizer;
    });
    var isLoggedIn = computed(function () {
      return auth.loggedIn;
    });
    var isGuestUser = computed(function () {
      var _userStore$user;
      return ((_userStore$user = userStore.user) === null || _userStore$user === void 0 ? void 0 : _userStore$user.type) === 'guest';
    });
    var isOrganizer = computed(function () {
      return !!(auth.loggedIn && showOrganizer && userCanAccessDashboard.value && getOrganizer.value);
    });
    var wordmarkUrl = computed(function () {
      var _whitelabelLite$wordm;
      return (_whitelabelLite$wordm = whitelabelLite === null || whitelabelLite === void 0 ? void 0 : whitelabelLite.wordmarkUrl) !== null && _whitelabelLite$wordm !== void 0 ? _whitelabelLite$wordm : require('assets/img/logo.svg');
    });
    var logomarkUrl = computed(function () {
      var _whitelabelLite$logom;
      return (_whitelabelLite$logom = whitelabelLite === null || whitelabelLite === void 0 ? void 0 : whitelabelLite.logomarkUrl) !== null && _whitelabelLite$logom !== void 0 ? _whitelabelLite$logom : require('assets/img/logo_footer.svg');
    });
    var isWhitelabelLite = computed(function () {
      return config.whitelabel.enabled;
    });
    var isImpersonated = computed(function () {
      var _auth$user, _sdk$credentials;
      return (auth === null || auth === void 0 ? void 0 : (_auth$user = auth.user) === null || _auth$user === void 0 ? void 0 : _auth$user.impersonated_by) || ((_sdk$credentials = sdk.credentials) === null || _sdk$credentials === void 0 ? void 0 : _sdk$credentials.type) === CredentialType.Impersonate;
    });
    var defaultPadding = computed(function () {
      return props.padding !== 0 ? "padding: 0 ".concat(props.padding, "px") : '';
    });
    var infoPageTitle = computed(function () {
      return isDashboardInfoPage.value ? t('main.dashboard') : t('main.profile');
    });
    var infoPageText = computed(function () {
      return isDashboardInfoPage.value ? t('mobileMenu.infoDashboardPage.description') : t('mobileMenu.infoProfilePage.description');
    });
    var emailVerified = computed(function () {
      var _auth$user2;
      return !!(auth !== null && auth !== void 0 && (_auth$user2 = auth.user) !== null && _auth$user2 !== void 0 && _auth$user2.verified);
    });
    onMounted(function () {
      // check scroll top to add style on header
      if (!props.isDashboard) {
        window.addEventListener('scroll', handleScroll);
      }
      if (window.scrollY > 0) {
        isScrolled.value = true;
      }
    });
    function redirectToDashboardInfoPage() {
      var _getOrganizer$value;
      if (canAccessMobileDashboard.value((_getOrganizer$value = getOrganizer.value) === null || _getOrganizer$value === void 0 ? void 0 : _getOrganizer$value.name)) {
        router.push(localePath('/mobile/my-events'));
        return;
      }
      isInfoPage.value = true;
      isDashboardInfoPage.value = true;
    }
    function redirectBack() {
      isInfoPage.value = false;
      isDashboardInfoPage.value = false;
    }
    function redirectToGoogleStore() {
      window.open(whitelabel.links.playStoreApp);
    }
    function redirectToAppleStore() {
      window.open(whitelabel.links.appStoreApp);
    }
    function fetchEvents() {
      eventsStore.setSearchTerm(searchTerm.value);
      switchMenu();
    }
    function switchMenu() {
      mobileMenu.value = !mobileMenu.value;
      isInfoPage.value = false;
      if (mobileMenu.value) {
        isScrolled.value = true;
      } else if (!mobileMenu.value && window.scrollY === 0) {
        isScrolled.value = false;
      }
    }
    function handleScroll() {
      if (window.scrollY > 0) {
        isScrolled.value = true;
      } else if (!mobileMenu.value && window.scrollY === 0) {
        isScrolled.value = false;
      }
    }
    function logout() {
      auth.logout();
      userStore.resetUser();
      appStore.clearAuthData();
      ordersStore.clearOrders();
      organizerSignupStore.clearStoreState();
      featurebaseReset();
      router.push(localePath('/'));
    }
    function login() {
      emit('openLogin');
    }
    function redirectToProfile() {
      router.push(localePath('/profile'));
      if (mobileMenu.value) {
        switchMenu();
      }
    }
    function redirectToPassword() {
      router.push(localePath('/profile/password'));
      switchMenu();
    }
    function redirectToPrivacy() {
      router.push(localePath('/profile/privacy'));
      switchMenu();
    }
    function redirectToOrders() {
      router.push(localePath('/profile/orders'));
      switchMenu();
    }
    function redirectToApiKeys() {
      router.push(localePath('/profile/api-keys'));
      switchMenu();
    }
    function redirectToIndex() {
      // We use the path as it does not include the query string
      // We match it with regex so that we can support new locales easily
      var homePathRegex = /^\/[a-zA-Z]{2}$/;
      var isHomePath = homePathRegex.test(router.currentRoute.path);
      if (isHomePath) {
        location.reload();
        return false;
      }
      router.push(localePath('/'));
    }
    function handleHelpClick() {
      nuxtEventBus.$emit('helpButtonClicked');
    }
    function handleHelpTicketClick() {
      if (!isLoggedIn.value) {
        emit('openLogin');
        return;
      }
      router.push(localePath('/profile/orders'));
    }
    function handleOrganizerSignUp() {
      if (!isLoggedIn.value) {
        emit('openLogin');
        return;
      }
      if (!emailVerified.value) {
        notifier.showMessage({
          content: t('organizerSignup.verifyEmailMessage'),
          type: 'warning'
        });
        return;
      }
      router.push(localePath('/organizer-signup'));
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      userStore: userStore,
      appStore: appStore,
      ordersStore: ordersStore,
      eventsStore: eventsStore,
      organizerSignupStore: organizerSignupStore,
      auth: auth,
      sdk: sdk,
      router: router,
      localePath: localePath,
      notifier: notifier,
      nuxtEventBus: nuxtEventBus,
      featurebaseReset: featurebaseReset,
      whitelabel: whitelabel,
      whitelabelLite: whitelabelLite,
      config: config,
      enableOrganizers: enableOrganizers,
      t: t,
      mobileMenu: mobileMenu,
      showOrganizer: showOrganizer,
      searchTerm: searchTerm,
      isScrolled: isScrolled,
      isInfoPage: isInfoPage,
      isDashboardInfoPage: isDashboardInfoPage,
      getDashboardUrl: getDashboardUrl,
      getUserEmail: getUserEmail,
      canAccessMobileDashboard: canAccessMobileDashboard,
      userCanAccessDashboard: userCanAccessDashboard,
      getOrganizer: getOrganizer,
      isLoggedIn: isLoggedIn,
      isGuestUser: isGuestUser,
      isOrganizer: isOrganizer,
      wordmarkUrl: wordmarkUrl,
      logomarkUrl: logomarkUrl,
      isWhitelabelLite: isWhitelabelLite,
      isImpersonated: isImpersonated,
      defaultPadding: defaultPadding,
      infoPageTitle: infoPageTitle,
      infoPageText: infoPageText,
      emailVerified: emailVerified,
      redirectToDashboardInfoPage: redirectToDashboardInfoPage,
      redirectBack: redirectBack,
      redirectToGoogleStore: redirectToGoogleStore,
      redirectToAppleStore: redirectToAppleStore,
      fetchEvents: fetchEvents,
      switchMenu: switchMenu,
      handleScroll: handleScroll,
      logout: logout,
      login: login,
      redirectToProfile: redirectToProfile,
      redirectToPassword: redirectToPassword,
      redirectToPrivacy: redirectToPrivacy,
      redirectToOrders: redirectToOrders,
      redirectToApiKeys: redirectToApiKeys,
      redirectToIndex: redirectToIndex,
      handleHelpClick: handleHelpClick,
      handleHelpTicketClick: handleHelpTicketClick,
      handleOrganizerSignUp: handleOrganizerSignUp,
      IconMenu: IconMenu,
      IconSearch: IconSearch,
      IconBack: IconBack,
      IconCancel: IconCancel,
      GooglePlay: GooglePlay,
      AppStore: AppStore,
      BImpersonated: BImpersonated,
      BLanguageSwitcher: BLanguageSwitcher,
      BLoggedUser: BLoggedUser
    };
  }
});